import React from 'react'
import { Trans } from '@lingui/macro'
import IconBubbles from '../../../../../components/common/icon/IconBubbles'
import IconStar from '../../../../../components/common/icon/IconStar'
import IconLike from '../../../../../components/common/icon/IconLike'

import { SmallMarbleRating } from '../../../../../components/common/marble-rating/SmallMarbleRating'
import { sum } from 'lodash'
import './FeedbackBox.less'
import { DashboardSummaryQuery } from '../../DashboardSummary.codegen'

interface IUserInsightsBoxProps {
  ratedCurrentEnrolments: NonNullable<
    NonNullable<
      NonNullable<DashboardSummaryQuery['admin']>['dashboard']
    >['ratedCurrentEnrolments']
  >
  commentsCount: number
}

export const FeedbackBox = ({
  ratedCurrentEnrolments,
  commentsCount
}: IUserInsightsBoxProps) => {
  const rating = ratedCurrentEnrolments.length
    ? Math.round(
        (sum(ratedCurrentEnrolments.map((e) => e.rating)) /
          ratedCurrentEnrolments.length) *
          100
      ) / 100
    : 0

  return (
    <div className="DataSummaryGrid__item">
      <div className="Box FeedbackBox">
        <div className="FeedbackBox__data">
          <div className="FeedbackBox__title">
            <IconLike />
            <div className="FeedbackBox__title__text">
              <Trans>Feedback</Trans>
            </div>
            <div className="FeedbackBox__title__number">
              {commentsCount + ratedCurrentEnrolments.length}
            </div>
            <div className="FeedbackBox__title__desc">
              <Trans>Sum of ratings and comments</Trans>
            </div>
          </div>

          <div className="FeedbackBox__right">
            <div className="FeedbackBox__right__block">
              <IconBubbles />
              <div className="FeedbackBox__right__block__number">
                {commentsCount}
              </div>
              <div className="FeedbackBox__right__block__desc">
                <Trans>Comments</Trans>
              </div>
            </div>
            <div className="FeedbackBox__right__block">
              <IconStar />
              <div className="FeedbackBox__right__block__number">{rating}</div>
              <div className="FeedbackBox__right__block__desc">
                <Trans>Avg. rating</Trans>
              </div>
              <SmallMarbleRating rating={rating} />
              <div className="FeedbackBox__right__block__count">
                ({ratedCurrentEnrolments.length})
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
